
import React, { Dispatch, SetStateAction, useEffect, useState } from "react";
import { FirmarEnviarSolicitudHE, GuardarBorradorSolicitudHE, ObtenerAniosSolicitudHE, ObtenerInformacionParaSolicitudHE, ObtenerMesesSolicitudHE, ObtenerUnidadesPlanificacionHE, VistaPreviaSolicitudHE, VistaPreviaSolicitudHEIngresada } from "./FunctionsSolicitudPagoHE";
import { MesesPlanificacionHEDTO } from "components/Admin/Horas Extras/Planificacion Horas Extras/TypesPlanificacionUnidades";


import { Table, Button, Input, PaginationItem, PaginationLink, Pagination, Container, Row, Col, Label, FormGroup } from "reactstrap"
import SelectItem2 from "components/Varios/SelectNew";
import { CreacionSolicitudHE, EstructuraOrganicaHEDTO, InformacionGeneralSolicitudHE, InformacionSolicitudHEServidor, JornadaLaboralSolicitadaHE, LocationSolicitudHE } from "./TypesSolicitudPagoHE";
import { showAlert, showAlertAviso } from "components/Admin/Horas Extras/Parametros Horas Extras/Actividades/ActividadesHorasExtras";

import ErrorSVG from "./../../../../assets/icons/HorasExtras/Error.svg"
import Cargando from "components/Varios/Cargando";
import TablaSolicitudHE from "./TablaSolicitudHE";
import { SelectCombo } from "components/Types/GeneralTypes";
import ModalCargando from "components/Varios/ModalCargando";
import ModalVistaPreviaDocumento from "components/Varios/Modals/ModalVistaPreviaDocumento";
import { ChangeToPromise } from "functions/GeneralFunctions";
import AlertEstadoSolicitudHE from "./AlertEstadoSolicitudHE";
import { classNameIconoFlechaRegresar } from "constants/Icons-Font-Awesome";
import { useHistory, useLocation } from "react-router";
import { GetDocumentVistaPrevia2 } from "helpers/files";
import ModalVistaPreviaDocumentos from "components/Varios/Modals/ModalVistaPreviaDocumentos";
import AlertNew, { TiposAlerta } from "components/Varios/AlertNew";

import PdfSVG from "assets/icons/Permisos/PDF(azul).svg"
import Swal from "sweetalert2";
import { EsMayorHora } from "functions/TimeFunctions";


export default function SolicitudPagoHE() {


    const location = useLocation();

    const { anio = 0, mes = 0 } = (location.state as LocationSolicitudHE) || {};


    const [aniosPlanificacion, setAniosPlanificacion] = useState<number[]>([]);
    const [mesesPlanificacion, setMesesPlanificacion] = useState<MesesPlanificacionHEDTO[]>([]);
    const [unidadesPlanificacion, setUnidadesPlanificacion] = useState<EstructuraOrganicaHEDTO[]>([]);

    const [errorMessage, setErrorMessage] = useState<string | null>(null);

    const [anioSeleccionado, setAnioSeleccionado] = useState<number>(anio);
    const [mesSeleccionado, setMesSeleccionado] = useState<number>(mes);
    const [unidadSeleccionada, setUnidadSeleccionada] = useState<number>(0);
    // const [anioSeleccionado, setAnioSeleccionado] = useState<number>(2024);
    // const [mesSeleccionado, setMesSeleccionado] = useState<number>(9);
    // const [unidadSeleccionada, setUnidadSeleccionada] = useState<number>(48);
    const [otraunidadSeleccionada, setOtraunidadSeleccionada] = useState<number>(0);

    const [informacionGeneralSolicitud, setinformacionGeneralSolicitud] = useState<InformacionGeneralSolicitudHE | undefined>(undefined)

    const [loading, setloading] = useState<boolean>(false)
    const [loadingJornadas, setloadingloadingJornadas] = useState<boolean>(false)
    const [guardandoSolicitud, setguardandoSolicitud] = useState<boolean>(false)
    const [vistaPrevia, setVistaPrevia] = useState<boolean>(false)
    const [urlVistaPrevia, seturlVistaPrevia] = useState<string>("")
    const [urlDocumentoIngresado, seturlDocumentoIngresado] = useState<string>("")
    const [loadingHojaMarcacion, setloadingHojaMarcacion] = useState<boolean>(false)
    const [urlHojaMarcacionVP, seturlHojaMarcacionVP] = useState<string>("")

    const [enviandoSolicitud, setenviandoSolicitud] = useState<boolean>(false)
    const [selectedDays, setselectedDays] = useState<{ [key: number]: JornadaLaboralSolicitadaHE } | undefined>(undefined)
    const history = useHistory();




    async function ObtenerAniosPlanificacion() {
        setloading(true)
        const informacionGeneral = await ObtenerAniosSolicitudHE();
        if (informacionGeneral.status === 200 && informacionGeneral.dataResponse && typeof informacionGeneral.dataResponse !== 'string') {

            const aniosDisponibles: number[] = informacionGeneral.dataResponse;
            setAniosPlanificacion(aniosDisponibles)
            // if (aniosDisponibles.length > 0) {
            //     setAnioSeleccionado(aniosDisponibles[0])
            // }
            setErrorMessage(null);
        } else {
            setAniosPlanificacion([]); // Set an empty state
            setErrorMessage(typeof informacionGeneral.errorMessage === 'string' ? informacionGeneral.errorMessage : 'Error desconocido'); // Set the error message
            //alertService.error(typeof informacionGeneral.errorMessage === 'string' ? informacionGeneral.errorMessage : 'Error desconocido'); // Show the error alert
        }
        setloading(false)
    }

    async function ObtenerMesesPlanificacionbyAnio(anioSeleccionado: number) {
        const informacionGeneral = await ObtenerMesesSolicitudHE(anioSeleccionado);
        if (informacionGeneral.status === 200 && typeof informacionGeneral.dataResponse !== 'string') {

            const mesesDisponibles: MesesPlanificacionHEDTO[] = informacionGeneral.dataResponse;


            setMesesPlanificacion(mesesDisponibles)
            setErrorMessage(null);
        } else {
            setMesesPlanificacion([]); // Set an empty state
            setErrorMessage(typeof informacionGeneral.errorMessage === 'string' ? informacionGeneral.errorMessage : 'Error desconocido'); // Set the error message
            //alertService.error(typeof informacionGeneral.errorMessage === 'string' ? informacionGeneral.errorMessage : 'Error desconocido'); // Show the error alert
        }
    }

    async function ObtenerUnidadesPlanificacionbyAniobyMes() {
        const informacionGeneral = await ObtenerUnidadesPlanificacionHE(anioSeleccionado, mesSeleccionado);
        if (informacionGeneral.status === 200 && informacionGeneral.dataResponse && typeof informacionGeneral.dataResponse !== 'string') {
            setUnidadesPlanificacion(informacionGeneral.dataResponse)

            //Se setea  por default la unidad del servidor o en la que ya se encuentre ingresada una solicitud de horas extras, que segun el servicio siempre deberia ser la primera cuando se consulta aquí.
            if (informacionGeneral.dataResponse && informacionGeneral.dataResponse.length > 0) {
                setUnidadSeleccionada(informacionGeneral.dataResponse[0].idEstructuraOrganica)
                // const unidadDondeLabora = informacionGeneral.dataResponse.find((ul) => ul.unidadPlanificada);
                // if (unidadDondeLabora) {
                //     setUnidadSeleccionada(unidadDondeLabora.idEstructuraOrganica)
                // }
            }
            setErrorMessage(null);
        } else {
            setUnidadesPlanificacion([]); // Set an empty state
            setErrorMessage(typeof informacionGeneral.errorMessage === 'string' ? informacionGeneral.errorMessage : 'Error desconocido'); // Set the error message
            showAlert(typeof informacionGeneral.errorMessage === 'string' ? informacionGeneral.errorMessage : 'Error desconocido', false, ErrorSVG)


            //alertService.error(typeof informacionGeneral.errorMessage === 'string' ? informacionGeneral.errorMessage : 'Error desconocido'); // Show the error alert
        }
    }

    async function ObtenerInformacionGeneralSolicitud(anioSeleccionado: number, mesSeleccionado: number, unidadSeleccionada: number, esPlanificada: boolean) {

        setloadingloadingJornadas(true)

        const informacionGeneral = await ObtenerInformacionParaSolicitudHE(anioSeleccionado, mesSeleccionado, unidadSeleccionada);






        if (informacionGeneral.status === 200 && informacionGeneral.dataResponse) {

            var copiaJornada: JornadaLaboralSolicitadaHE[] = [...informacionGeneral.dataResponse.detalleJornada];
            var copiaInformacionGeneral: InformacionGeneralSolicitudHE = { ...informacionGeneral.dataResponse };


            if (!esPlanificada) {
                for (let index = 0; index < copiaJornada.length; index++) {
                    const element = copiaJornada[index];
                    if (element.puedeSolicitarHorasExtras) {
                        copiaJornada[index].planificada = "N"
                    }

                }

                copiaInformacionGeneral.detalleJornada = copiaJornada
            }



            setinformacionGeneralSolicitud(copiaInformacionGeneral)
            // if (copiaInformacionGeneral.parametros.minimoMinutos > 0) {

            //     const [horas, minutos] = copiaInformacionGeneral.parametros.timeMinimoMinutos.split(":");

            //     showAlertAviso(`<div>Recuerde que el tiempo para solicitar horas extras,<div/><div>debe ser mayor a ${horas}h:${minutos}m</div>`)
            // }


        } else {
            const mensajeDefault: string = "Ha ocurrido un evento inesperado";
            showAlert(informacionGeneral.errorMessage ?? mensajeDefault, false, ErrorSVG)
            setinformacionGeneralSolicitud(undefined)
        }

        setloadingloadingJornadas(false)
    }

    async function GuardarSolicitudHE(seleccionados: { [key: number]: JornadaLaboralSolicitadaHE }) {

        setguardandoSolicitud(true)
        var diasAsociadosSolicitud: JornadaLaboralSolicitadaHE[] = [];

        for (const key in seleccionados) {
            if (seleccionados.hasOwnProperty(key)) { // Verificar que la propiedad es del objeto
                const jornada = seleccionados[Number(key)]; // Convertir la clave a número
                diasAsociadosSolicitud.push(jornada);
            }
        }



        const solicitud: CreacionSolicitudHE = {
            anio: anioSeleccionado,
            mes: mesSeleccionado,
            idEstructuraOrganica: unidadSeleccionada,
            diasSolicitar: diasAsociadosSolicitud
        }

        const respuestaCreacion = await GuardarBorradorSolicitudHE(solicitud);

        if (respuestaCreacion.status === 200) {

            await ObtenerInformacionGeneralSolicitud(anioSeleccionado, mesSeleccionado, unidadSeleccionada, unidadSeleccionada !== 0)
            //showAlert("La solicitud ha sido guardada con éxito", true);
            const texto = `<div class="custom-modal-content">
                                        <p> La solicitud ha sido guardada con éxito</p>
                                        <br/>
                                        <strong>
                                            Recuerde firmar y enviar la solicitud a su directivo para la aprobación respectiva
                                        </strong>
                                    </div>`;



            const result = await Swal.fire({
                html: texto,
                icon: 'success',
                showCancelButton: false,
                confirmButtonText: 'Aceptar',
                customClass: {
                    //cancelButton: 'btn-cancelar',
                    confirmButton: 'btn-aceptar',
                    popup: 'custom-popup'
                },
            });


            if (result.isConfirmed) {
                handleGoBack()
            } else if (result.isDismissed && result.dismiss === Swal.DismissReason.cancel) {
                handleGoBack()
            } else {
                return;
            }
        }
        else {
            const mensajeDefault = "Ha ocurrido un inconveniente al intentar guardar su solicitud de Horas Extras."
            showAlert(respuestaCreacion.errorMessage ?? mensajeDefault, false);
        }
        setguardandoSolicitud(false)
    }

    async function CargarVistaPreviaSolicitudHE(seleccionados: { [key: number]: JornadaLaboralSolicitadaHE }) {

        setVistaPrevia(true)
        var diasAsociadosSolicitud: JornadaLaboralSolicitadaHE[] = [];

        for (const key in seleccionados) {
            if (seleccionados.hasOwnProperty(key)) { // Verificar que la propiedad es del objeto
                const jornada = seleccionados[Number(key)]; // Convertir la clave a número
                diasAsociadosSolicitud.push(jornada);
            }
        }



        const solicitud: CreacionSolicitudHE = {
            anio: anioSeleccionado,
            mes: mesSeleccionado,
            idEstructuraOrganica: unidadSeleccionada,
            diasSolicitar: diasAsociadosSolicitud
        }

        const respuestaCreacion = await VistaPreviaSolicitudHE(solicitud);

        if (respuestaCreacion.status === 200 && respuestaCreacion.dataResponse) {
            seturlVistaPrevia(respuestaCreacion.dataResponse)
            setselectedDays(seleccionados)
        }
        else {
            const mensajeDefault = "Ha ocurrido un inconveniente al intentar generar la vista previa de su solicitud de Horas Extras."
            showAlert(respuestaCreacion.errorMessage ?? mensajeDefault, false);
        }
        setVistaPrevia(false)
    }

    async function EnviarSolicitudHEDirectivo(seleccionados: { [key: number]: JornadaLaboralSolicitadaHE }) {

        setenviandoSolicitud(true)
        var diasAsociadosSolicitud: JornadaLaboralSolicitadaHE[] = [];

        for (const key in seleccionados) {
            if (seleccionados.hasOwnProperty(key)) { // Verificar que la propiedad es del objeto
                const jornada = seleccionados[Number(key)]; // Convertir la clave a número
                diasAsociadosSolicitud.push(jornada);
            }
        }



        const solicitud: CreacionSolicitudHE = {
            anio: anioSeleccionado,
            mes: mesSeleccionado,
            idEstructuraOrganica: unidadSeleccionada,
            diasSolicitar: diasAsociadosSolicitud
        }

        const respuestaCreacion = await FirmarEnviarSolicitudHE(solicitud);

        if (respuestaCreacion.status === 200) {


            await ObtenerInformacionGeneralSolicitud(anioSeleccionado, mesSeleccionado, unidadSeleccionada, unidadSeleccionada !== 0)

            //showAlert("La solicitud ha sido firmada y envíada a su directivo", true);
            const texto = `<div class="custom-modal-content">
                                        <p> La solicitud ha sido firmada y envíada a su directivo </p>
                                    </div>`;



            const result = await Swal.fire({
                html: texto,
                icon: 'success',
                showCancelButton: false,
                confirmButtonText: 'Aceptar',
                customClass: {
                    //cancelButton: 'btn-cancelar',
                    confirmButton: 'btn-aceptar',
                    popup: 'custom-popup'
                },
            });


            if (result.isConfirmed) {
                handleGoBack()
            } else if (result.isDismissed && result.dismiss === Swal.DismissReason.cancel) {
                handleGoBack()
            } else {
                return;
            }



        }
        else {
            const mensajeDefault = "Ha ocurrido un inconveniente al intentar enviar su solicitud de Horas Extras."
            showAlert(respuestaCreacion.errorMessage ?? mensajeDefault, false);
        }
        setenviandoSolicitud(false)
    }




    function ObtenerOpcionesUnidades(listadoUnidades: EstructuraOrganicaHEDTO[], planificaron: boolean) {
        var listadoOpciones: SelectCombo[] = [];
        if (listadoUnidades.length > 0) {
            const filtrados = listadoUnidades.filter((u) => u.unidadPlanificada === planificaron);

            listadoOpciones = filtrados.map((v, i) => { return { label: v.nombreEstructuraOrganica, value: v.idEstructuraOrganica.toString() } })
        }

        return listadoOpciones;

    }


    function ObtenerDetalleEstructuraDeSeleccion(idunidad: number, listadoUnidades: EstructuraOrganicaHEDTO[]) {
        const unidad = listadoUnidades.find((v) => v.idEstructuraOrganica === idunidad);
        return unidad;
    }


    function MapearDiasSeleccionados(informacion: InformacionGeneralSolicitudHE) {

        var jornadasSeleccionada: JornadaLaboralSolicitadaHE[] = [...informacion.detalleJornada]
        jornadasSeleccionada = jornadasSeleccionada.filter((v) => v.estadoDiaHE === "A")

        if (jornadasSeleccionada.length === 0) {
            return []
        }
        else {
            const diasSeleccionados: { [key: number]: JornadaLaboralSolicitadaHE } = jornadasSeleccionada.reduce(
                (acc, jornada) => {
                    acc[jornada.idJornada] = jornada;
                    return acc;
                },
                {} as { [key: number]: JornadaLaboralSolicitadaHE }
            );

            return diasSeleccionados
        }

    }
    async function GenerarVistaPreviaSolicitudHE(idSolicitudHE: number) {
        setVistaPrevia(true)

        const respuestaVistaPrevia = await VistaPreviaSolicitudHEIngresada(idSolicitudHE);

        if (respuestaVistaPrevia.status === 200 && respuestaVistaPrevia.dataResponse) {
            seturlDocumentoIngresado(respuestaVistaPrevia.dataResponse)
        }
        else {
            showAlert("No es posible cargar la vista previa del documento", false);
        }


        setVistaPrevia(false)
    }

    async function OnClickDocumento(informacion: InformacionSolicitudHEServidor) {
        if (informacion.refArchivo) {
            setVistaPrevia(true)
            const url = await GetDocumentVistaPrevia2(informacion.refArchivo)
            if (url) {
                seturlDocumentoIngresado(url)
            }
            setVistaPrevia(false)
        }
        else {
            await GenerarVistaPreviaSolicitudHE(informacion.idSolicitudHorasExtras)
        }
    }

    async function OnClickDocumentoHojaMarcacion(refArchivo: string) {
        if (refArchivo) {
            setloadingHojaMarcacion(true)
            const url = await GetDocumentVistaPrevia2(refArchivo)
            if (url) {
                seturlHojaMarcacionVP(url)
            }
            setloadingHojaMarcacion(false)
        }
        else {
            showAlert("Referencia de archivo no válida", false)
        }
    }


    useEffect(() => {
        ObtenerAniosPlanificacion()
    }, [])

    useEffect(() => {
        if (anioSeleccionado > 0) {
            ObtenerMesesPlanificacionbyAnio(anioSeleccionado)
        }
        else {
            if (aniosPlanificacion.length > 0) {
                setAnioSeleccionado(aniosPlanificacion[0])
            }
        }
        // else{
        //     ObtenerAniosPlanificacion()
        // }

    }, [anioSeleccionado, aniosPlanificacion])

    useEffect(() => {
        if (anioSeleccionado !== 0 && mesSeleccionado !== 0) {
            ObtenerUnidadesPlanificacionbyAniobyMes()
        }
    }, [anioSeleccionado, mesSeleccionado])

    useEffect(() => {
        if (anioSeleccionado !== 0 && mesSeleccionado !== 0 && unidadSeleccionada !== 0) {
            ObtenerInformacionGeneralSolicitud(anioSeleccionado, mesSeleccionado, unidadSeleccionada, true)
        }
    }, [anioSeleccionado, mesSeleccionado, unidadSeleccionada])

    useEffect(() => {
        if (anioSeleccionado !== 0 && mesSeleccionado !== 0 && otraunidadSeleccionada !== 0) {
            ObtenerInformacionGeneralSolicitud(anioSeleccionado, mesSeleccionado, otraunidadSeleccionada, false)
        }
    }, [anioSeleccionado, mesSeleccionado, otraunidadSeleccionada])

    const handleChangeSelect = (setter: Dispatch<SetStateAction<number>>, name: string) => (value: string | number) => {


        if (name === "unidadnoplanificada") {
            setUnidadSeleccionada(0)
        }
        else if (name === "unidadplanificada") {
            setOtraunidadSeleccionada(0)
        }
        setter(Number(value));
    };

    const handleGoBack = () => {
        history.push('/web/horasextras/')
    };


    const TITULO_PANTALLA = `SOLICITUD PARA REPORTAR LAS HORAS EXTRAS LABORADAS DEL MES`;
    const [horas, minutos] = informacionGeneralSolicitud ? informacionGeneralSolicitud.parametros.timeMinimoMinutos.split(":") : "00:00".split(":");

    //     showAlertAviso(`<div>Recuerde que el tiempo para solicitar horas extras,<div/><div>debe ser mayor a ${horas}h:${minutos}m</div>`)

    return (
        <div className='content'>

            <div className="titulo_seccion mb-3">
                <i className={`icono-flecha-regresar ${classNameIconoFlechaRegresar}`} onClick={handleGoBack} title='Regresar' />
                {TITULO_PANTALLA}
            </div>
            <Container fluid={true}>
                {
                    !loadingJornadas && informacionGeneralSolicitud &&
                    <>
                        {
                            EsMayorHora(informacionGeneralSolicitud.parametros.timeMinimoMinutos, "00:00") &&
                            <Row className="mb-1">
                                <Col xl={12}>
                                    <AlertNew
                                        mensaje={`Recuerde que para solicitar horas extras Ud. debe haber laborado en días ordinarios más de  ${horas}h:${minutos}m`}
                                        oncloseElement={() => console.log()}
                                        tipo={TiposAlerta.PARA_CONOCIMIENTO}
                                    />
                                </Col>
                            </Row>
                        }


                        <Row className="justify-content-end">

                            <Col md="auto">
                                <AlertEstadoSolicitudHE
                                    estadoSolicitud={informacionGeneralSolicitud.informacionSolicitud === null ? "" : informacionGeneralSolicitud.informacionSolicitud.estado}
                                    oncloseElement={function (): void { ; }}
                                    closeButton={false}
                                    className="alert-lado-derecho"  // Añadir una clase personalizada si es necesario
                                />
                            </Col>
                        </Row>

                        <Row className="justify-content-end mt-1 mb-1">
                            <Col md="auto">
                                <div className="clickhojaMarcacion" onClick={() => { OnClickDocumentoHojaMarcacion(informacionGeneralSolicitud.refhojamarcacion) }}>
                                    <img
                                        src={PdfSVG}
                                        className="iconPDF"
                                        alt={`Hoja marcaciones`}
                                        style={{ width: 24, height: 24 }}
                                    />
                                    Ver Hoja de Marcaciones del mes

                                </div>

                            </Col>

                        </Row>



                    </>

                }


                <Row className="mt-1 mb-1">
                    <Col xl={2}>
                        <FormGroup>
                            <Label for="anio">Año*</Label>
                            <SelectItem2
                                options={aniosPlanificacion.map(anio => ({ value: anio, label: anio }))}
                                placeholder=""
                                name="anio"
                                id="anio"
                                icon="fa-caret-down"
                                value={anioSeleccionado}
                                onChange={(v, n, t, l) => {
                                    setAnioSeleccionado(+v)
                                    setMesSeleccionado(0);
                                }
                                }
                            />
                        </FormGroup>
                    </Col>
                    <Col xl={2}>
                        <FormGroup>
                            <Label for="mes">Mes*</Label>
                            <SelectItem2
                                options={mesesPlanificacion.map(mes => ({ value: mes.numeroMes, label: mes.nombreMes }))}
                                placeholder=""
                                name="mes"
                                id="mes"
                                icon="fa-caret-down"
                                value={mesSeleccionado}
                                onChange={handleChangeSelect(setMesSeleccionado, "mes")}
                            />
                        </FormGroup>
                    </Col>

                    <Col xl={6}>
                        <FormGroup>
                            <Label for="mes">Unidad*</Label>
                            <SelectItem2
                                options={ObtenerOpcionesUnidades(unidadesPlanificacion, true)}
                                placeholder=""
                                name="unidadplanificada"
                                id="mes"
                                icon="fa-caret-down"
                                value={unidadSeleccionada}
                                onChange={handleChangeSelect(setUnidadSeleccionada, "unidadplanificada")}
                            />
                        </FormGroup>
                    </Col>
                </Row>

                {/* <Row>
                    <Col xl={3}>
                        <FormGroup>
                            <Label for="mes">Unidades para actividades no planificadas*</Label>
                            <SelectItem2
                                options={ObtenerOpcionesUnidades(unidadesPlanificacion, false)}
                                placeholder=""
                                name="unidadnoplanificada"
                                id="mes"
                                icon="fa-caret-down"
                                value={otraunidadSeleccionada}
                                onChange={handleChangeSelect(setOtraunidadSeleccionada, "unidadnoplanificada")}
                            />
                        </FormGroup>
                    </Col>
                </Row> */}

                {
                    loadingJornadas && <Cargando mensaje="Obteniendo Información de Jornada..." />
                }
                {
                    !loadingJornadas && informacionGeneralSolicitud !== undefined && ObtenerDetalleEstructuraDeSeleccion(unidadSeleccionada, unidadesPlanificacion) &&
                    <TablaSolicitudHE
                        mesSolicitud={mesSeleccionado}
                        fechaActual={informacionGeneralSolicitud.fechaActual}
                        actividadesPlanificadas={informacionGeneralSolicitud.actividadesPlanificadas}
                        estadosJornada={informacionGeneralSolicitud.estadosJornada}
                        detalleJornada={informacionGeneralSolicitud.detalleJornada}
                        estructuraSeleccionada={ObtenerDetalleEstructuraDeSeleccion(unidadSeleccionada, unidadesPlanificacion)}
                        parametros={informacionGeneralSolicitud.parametros}
                        selectedDays={MapearDiasSeleccionados(informacionGeneralSolicitud)}
                        guardarSolicitud={(s) => GuardarSolicitudHE(s)}
                        enviarFirmarSolicitud={(s) => CargarVistaPreviaSolicitudHE(s)}
                        informacionSolicitud={informacionGeneralSolicitud.informacionSolicitud}
                        onClickVerSolicitud={(info: InformacionSolicitudHEServidor) => OnClickDocumento(info)}
                    />
                }

                {
                    !loadingJornadas && informacionGeneralSolicitud !== undefined && ObtenerDetalleEstructuraDeSeleccion(otraunidadSeleccionada, unidadesPlanificacion) &&
                    <TablaSolicitudHE
                        mesSolicitud={mesSeleccionado}
                        fechaActual={informacionGeneralSolicitud.fechaActual}
                        actividadesPlanificadas={informacionGeneralSolicitud.actividadesPlanificadas}
                        estadosJornada={informacionGeneralSolicitud.estadosJornada}
                        detalleJornada={informacionGeneralSolicitud.detalleJornada}
                        estructuraSeleccionada={ObtenerDetalleEstructuraDeSeleccion(otraunidadSeleccionada, unidadesPlanificacion)}
                        parametros={informacionGeneralSolicitud.parametros}
                        selectedDays={MapearDiasSeleccionados(informacionGeneralSolicitud)}
                        guardarSolicitud={(s) => GuardarSolicitudHE(s)}
                        enviarFirmarSolicitud={(s) => CargarVistaPreviaSolicitudHE(s)}
                        informacionSolicitud={informacionGeneralSolicitud.informacionSolicitud}
                        onClickVerSolicitud={(info: InformacionSolicitudHEServidor) => OnClickDocumento(info)}
                    />
                }



                {
                    <ModalCargando
                        show={guardandoSolicitud || vistaPrevia}
                        textoCargando={guardandoSolicitud ? "Guardando Solicitud" : vistaPrevia ? "Generando Vista Previa" : ""}
                        size={"md"}
                        onClose={() => setguardandoSolicitud(false)}
                    />
                }




                {
                    selectedDays !== undefined &&
                    <ModalVistaPreviaDocumento
                        show={urlVistaPrevia !== "" && selectedDays !== undefined}
                        urlArchivo={urlVistaPrevia}
                        size="xl"
                        tituloModal=""
                        cargandoDatos={vistaPrevia}
                        onClose={() => { seturlVistaPrevia(""); setselectedDays(undefined) }}
                        accionOnAccept={true}
                        asyncAccion={() => EnviarSolicitudHEDirectivo(selectedDays)}
                        closeAfterAsync={true}
                        botonCerrar={true}
                        zoomDefaultValue={1.5}

                    />
                }
                <ModalVistaPreviaDocumentos
                    show={urlDocumentoIngresado !== ""}
                    urlArchivo={urlDocumentoIngresado}
                    size="xl"
                    tituloModal=""
                    cargandoDatos={vistaPrevia}
                    onClose={() => { seturlDocumentoIngresado(""); setselectedDays(undefined) }}
                    botonCerrar={false}


                />
                <ModalVistaPreviaDocumentos
                    show={loadingHojaMarcacion || urlHojaMarcacionVP !== ""}
                    cargandoDatos={loading}
                    size='xl'
                    tituloModal='Hoja Marcaciones'
                    onClose={() => seturlHojaMarcacionVP("")}
                    urlArchivo={urlHojaMarcacionVP}
                    allHeight={true}
                />
            </Container>



        </div>
    )
}
